const ember = {
  id: 'ember',
  displayName: 'Ember',
  enabled: true,
  graph: {
    writeSample: '#FFC107', writeTrend: '#EBEBEB', writeMax: '#4CAF50',
    writeMin: '#FF5722', writeLatency: '#FFC107',
    readSample: '#E91E63', readTrend: '#D3D3D3', readMax: '#66BB6A',
    readMin: '#F44336', readLatency: '#E91E63',
  },
  canvas: {
    chartBg: '#2B2B2B', gridColor: '#444444', textColor: '#ADB5BD',
  },
};
export default ember;
